import React from 'react';
import moment from 'moment';
import translateEntries from '../../../controllers/translateEntries';
import { locales } from '../../../translations/locales';

const Entrie = (props) => {
    const { entrie, locale } = props;
    return (
        <div className='p-1 m-1 border border-secondary rounded'>
            <h6>
                <span className={`m-1 badge badge-${entrie.type === 'update' || entrie.type === 'select' ? 'warning' :
                    entrie.type === 'logBook' ? 'info' :
                        entrie.type === 'status' ? 'primary' :
                            entrie.type === 'alert' || entrie.type === 'create' ? 'danger' :
                                'secondary'}`}>
                    {locales[locale].sgo[entrie.type || 'update'] || (entrie.type || 'update')}
                </span>
                {moment(entrie.timestamp).format('DD/MM/YYYY HH:mm')}
            </h6>
            <p>
                {translateEntries(entrie.entrie, locale)}
            </p>
        </div>
    );
};

export default Entrie;
